import { paymentMethodApi } from "../api";

const PaymentMethodService = {
  fetchDropdown: async () => {
    const response = await paymentMethodApi.fetchCustom('/dropdown');
    return response.data;
  },
};

export default PaymentMethodService;
